import { createApp } from 'vue'
import Settings from './settings.vue';
import { createPinia } from "pinia";
// import '../node_modules/element-plus/theme-chalk/src/notification.scss';
import './assets/main.scss';
// import './assets/global.css';
import 'element-plus/es/components/notification/style/css';
import 'element-plus/dist/index.css';
import './Assets/settings.scss';


const pinia = createPinia();
const app = createApp(Settings);
app.use(pinia);


app.mount('#fv-settings-general')
